import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../../../shared/services/user.service';
import { User } from '../../../shared/models/user.model';
import { BaseComponent } from '../../../shared/class/base-component.class';
import { ApiResponse } from '../../../shared/interfaces/api-response.interface';

@Component({
  selector: 'app-view-user',
  templateUrl: './view-user.component.html',
  styleUrl: './view-user.component.scss'
})
export class ViewUserComponent extends BaseComponent implements OnInit {
  userDetails: User | undefined;
  userId?: number;
  userCountry = '';
  profilePicUrl = '';
  userName = '';

  ngOnInit(): void {
    const userId = this.route.snapshot.params['id'];
    this.getUserDetails(userId);
  }

  async getUserDetails(userId: number) {
    if (userId) {

      let response: ApiResponse<User> = await this.httpService.httpRequest<User>(
        "user",
        "get-by-admin",
        {
          id: userId,
          relations: 'organization'
        }
      );
      if (response.status) {
        this.userDetails = response.data!;
        return;
      }
    }
  }
}
